import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { dayjs } from '@umanforge/common';
import { Breaktime } from 'interfaces/breaktime.interface';
import InputTime from 'components/inputs/selectTime.component';
import { TrashIcon } from '@common_components/icons/trash.icon';
interface BreaktimeProps {
  breaktime: Breaktime;
  onDelete?: ( breaktime: Breaktime ) => void;
  onChange?: () => void;
}

const BreaktimeTile: React.FC<BreaktimeProps> = ( {
  breaktime,
  onDelete = () => { /* */},
  onChange = () => { /* */ }
} ) => {
  const { t } = useTranslation();
  const [ , setIsFirstRender ] = useState<boolean>( true );

  const [ timeStart, setTimeStart ] = useState<dayjs.Dayjs>( dayjs( breaktime.timeStart ) );
  const [ timeEnd, setTimeEnd ] = useState<dayjs.Dayjs>( dayjs( breaktime.timeEnd ) );

  useEffect( () => {
    breaktime.timeStart = timeStart.toISOString();
    onChange();
  }, [ timeStart ] );

  useEffect( () => {
    breaktime.timeEnd = timeEnd.toISOString();
    onChange();
  }, [ timeEnd ] );



  useEffect( () => {
    setIsFirstRender( false );
  }, [] );

  // Render
  return (
    <div className='rounded border border-gray-300 shadow flex p-1'>
      <div className='w-full flex self-center ml-2'>
        <div className='w-1/2 flex text-sm text-gray-600'>
          <InputTime
            step={15}
            min={ dayjs( ).startOf( 'day' ) }
            max={ dayjs( ).endOf( 'day' ) }
            value={ dayjs().startOf( 'day' ).add( timeStart.hour(), 'hour' ).add( timeStart.minute(), 'minute' ) }
            onChange={ setTimeStart }
            disable={ false }
            textSize='w-auto mr-4'
            inputClassName='p-0 min-h-7 h-7'
            iconClassName='p-0 w-5 -mt-2'
            label={ t( 'Heure de début:' ) }
          />
        </div>
        <div className='w-1/2 flex text-sm text-gray-600'>
          <InputTime
            step={15}
            min={ dayjs( ).startOf( 'day' ) }
            max={ dayjs( ).endOf( 'day' ) }
            value={ dayjs().startOf( 'day' ).add( timeEnd.hour(), 'hour' ).add( timeEnd.minute(), 'minute' ) }
            onChange={ setTimeEnd }
            disable={ false }
            textSize='w-auto mr-4'
            inputClassName='p-0 min-h-7 h-7'
            iconClassName='p-0 w-5 -mt-2'
            label={ t( 'Heure de fin:' ) }
          />
        </div>
      </div>
      <div className='flex w-fit'>
        <button className='m-0.5 -mb-0.5 cursor-pointer' onClick={ () => { onDelete( breaktime ); } }>
          <div className='w-full inline-flex justify-center rounded-lg bg-white/60 hover:bg-white/90 hover:outline-1 hover:outline hover:outline-slate-400'>
            <TrashIcon size={5} className='hover:text-red-500 text-[#EE3333]' />
          </div>
        </button>
      </div>
    </div>
  );
};

export default BreaktimeTile;
